import React, { PropsWithChildren } from 'react'

import ErrorText from '@components/atoms/ErrorText'

import FormField from '@helper/FormField'

import { ErrorMessage } from '../ErrorMessage'
import { Input, Root, StyledInputLabel } from './InputDate.styles'

interface Props extends FormField {
  placeholder?: string
  value: string
  errorChildren?: React.ReactNode
}

const InputDate: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.JSX.Element => {
  const {
    errorChildren,
    dataTestId,
    disabled,
    error,
    errorText,
    label,
    forId,
    required,
    register,
    placeholder,
  } = props
  return (
    <Root className={props.className} data-testid={'input-date-root'}>
      {label && (
        <StyledInputLabel
          error={error ?? false}
          disabled={disabled ?? false}
          required={required ?? false}
          forId={forId}
        >
          {label}
        </StyledInputLabel>
      )}
      <Input
        error={error ?? false}
        type="date"
        required={required}
        placeholder={placeholder}
        id={forId}
        {...register}
      />
      {error && errorChildren != null && (
        <ErrorMessage
          dataTestId={(dataTestId ?? forId) + '-error'}
          variant="destructive"
        >
          {errorChildren}
        </ErrorMessage>
      )}
      {error && errorChildren == null && Boolean(errorText) && (
        <ErrorText dataTestId={(dataTestId ?? forId) + '-error'}>
          {errorText}
        </ErrorText>
      )}
    </Root>
  )
}

export { InputDate }
